import { render, staticRenderFns } from "./checklist-select-priority.vue?vue&type=template&id=18c1c147&scoped=true"
import script from "./checklist-select-priority.vue?vue&type=script&lang=js"
export * from "./checklist-select-priority.vue?vue&type=script&lang=js"
import style0 from "./checklist-select-priority.vue?vue&type=style&index=0&id=18c1c147&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1c147",
  null
  
)

export default component.exports